module.exports = __webpack_public_path__ + "static/media/HackAndRollLogo.8e2086c0.png";